import { render, staticRenderFns } from "./ShoppingCart.vue?vue&type=template&id=7457bf97&scoped=true&"
import script from "./ShoppingCart.vue?vue&type=script&lang=js&"
export * from "./ShoppingCart.vue?vue&type=script&lang=js&"
import style1 from "./ShoppingCart.vue?vue&type=style&index=1&id=7457bf97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7457bf97",
  null
  
)

export default component.exports